<template>
  <div>
    <router-link
      :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
      class="member-name"
    >{{news.textParams[1]}}</router-link>
    {{$t('news.template.proposal.publish.by.2.consolidated.p1')}}
    <router-link
      :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[5]}}"
      class="member-name"
    >{{news.textParams[6]}}</router-link>
    {{$t('news.template.proposal.publish.by.2.consolidated.p2')}} <a
      class="consolidated-news"
      href="#"
      @click.prevent="updateConsolidatedNewsList(news.stringChildIds)"
    >{{news.textParams[2]}}
      {{$t('news.template.proposal.publish.by.2.consolidated.p3')}}</a>
    {{$t('news.template.proposal.publish.by.2.consolidated.p4')}}
    <router-link
      :to="{name: 'forum', params: {id: news.textParams[3]}}"
    >{{ news.textParams[4] }}
    </router-link>
  </div>
</template>

<script>
import { mapActions } from "pinia";
import { newsStore } from "@/store/newsStore";

export default {
  props: {
    news: {
      type: Object,
    },
  },
  methods: {
    ...mapActions(newsStore, ['updateConsolidatedNewsList']),
  },
};
</script>
